import { IconProps } from 'components/Shared/Icon';
import { IconBase } from 'components/Shared/Icon/themes/BGH-RD3/iconBase';

type Thickness = 'thin' | 'thick';
export const IconArrow = ({ thickness, ...props }: IconProps & { thickness?: Thickness }) => (
  <IconBase {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M14.34 40.3l17.32-17.33L14.4 5.71"
      />
    </svg>
  </IconBase>
);
